import PropTypes from "prop-types";
import React, { Component } from "react";
import DropdownButton from "react-bootstrap/DropdownButton";
import DropdownItem from "react-bootstrap/DropdownItem";
import { FormattedMessage, useIntl } from "react-intl";
import { OTHER_OPTION, PREDEFINED_LIST_TYPE } from "../../../../ducks/surveyEditor";
import ObjectUtils, { coalesce } from "../../../../utils/ObjectUtils";

import { Container, FormGroup } from "react-bootstrap";
import Checkbox from "../../../common/Checkbox";
import InfoTooltip from "../../surveyView/questions/renderer/InfoTooltip";
import Choice from "../Choice";
import QuestionHeader from "./QuestionHeader";

export default class MultiChoice extends Component {
  render() {
    const {
      changeQuestionField,
      pageName,
      question,
      addQuestionChoice,
      removeQuestionChoice,
      reorderChoice,
      intl,
      loadPredefinedList,
      loadIndicators,
      addIndicatorToQuestion,
      removeIndicatorFromQuestion,
      allIndicators,
      libraryQuestion
    } = this.props;
    return (
      <QuestionHeader
        changeQuestionField={changeQuestionField}
        pageName={pageName}
        question={question}
        loadPredefinedList={loadPredefinedList}
        addQuestionChoice={addQuestionChoice}
        intl={intl}
        addIndicatorToQuestion={addIndicatorToQuestion}
        removeIndicatorFromQuestion={removeIndicatorFromQuestion}
        loadIndicators={loadIndicators}
        allIndicators={allIndicators}
        libraryQuestion={libraryQuestion}
      >
        {question.type === "predefinedList" ? (
          <PredefinedList
            {...{
              changeQuestionField,
              pageName,
              question,
              intl,
              loadPredefinedList
            }}
          />
        ) : (
          <ConfigComponent
            {...{
              changeQuestionField,
              pageName,
              question,
              addQuestionChoice,
              removeQuestionChoice,
              reorderChoice
            }}
          />
        )}
      </QuestionHeader>
    );
  }
}

const ConfigComponent = ({
  editable,
  changeQuestionField,
  pageName,
  question,
  addQuestionChoice,
  removeQuestionChoice,
  reorderChoice,
  choiceTarget,
  parentChoiceName,
  parentChoiceTarget,
  showExclusive,
  exclusiveName,
  otherOptionField
}) => {
  const intl = useIntl();
  let choiceList = coalesce(ObjectUtils.getDeepProperty(question, coalesce(choiceTarget, "choices")), []);

  return (
    <>
      <h6>
        <FormattedMessage id="survey.editor.choices" />
      </h6>
      {choiceList.map((choice, i) => {
        let choiceName = coalesce(choice.name, choice.value);
        if (question.type === "radio" || question.type === "dropdown" || question.type === "checkbox") {
          editable = !choice.unchangeable;
        } else if ("tempChoices"===choiceTarget) {
          editable = choice.editable !== false;
        }
        return (
          <Choice
            key={choiceName + i}
            editable={editable}
            showRequiredToggle={false}
            showVisibleToggle={false}
            choiceName={choiceName}
            choiceText={choice.text}
            choiceKey={choice.key}
            parentChoiceName={parentChoiceName}
            parentChoiceTarget={parentChoiceTarget}
            changeQuestionField={changeQuestionField}
            question={question}
            pageName={pageName}
            addQuestionChoice={addQuestionChoice}
            removeQuestionChoice={removeQuestionChoice}
            choiceTarget={choiceTarget}
            reorderChoice={reorderChoice}
            infoText={choice.infoText}
            choiceDescriptionVisible={choice.choiceDescriptionVisible}
            letter={65 + i}
            showExclusive={question.type === "checkbox" || showExclusive}
            exclusiveName={exclusiveName}
          />
        );
      }, this)}

      {(question.type === "radio" ||
        question.type === "dropdown" ||
        question.type === "checkbox" ||
        parentChoiceName) && (
        <FormGroup  className="mb-3">
          <Checkbox
            checked={question[coalesce(otherOptionField, OTHER_OPTION)]}
            disabled={!editable}
            onChange={(e) => {
              changeQuestionField(pageName, question.name, coalesce(otherOptionField, OTHER_OPTION), e.target.checked);
            }}
          >
            <FormattedMessage id="survey.editor.toolbox.radio.other" />{" "}
            <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.toolbox.radio.other.info" })} />
          </Checkbox>
        </FormGroup>
      )}
    </>
  );
};

const PredefinedList = ({ changeQuestionField, pageName, question, intl, loadPredefinedList, otherOptionField, disabled }) => (
  <>
    <h6>
      <FormattedMessage id="survey.editor.choices" />
    </h6>
    <Container fluid className="mb-3 px-3 pt-4 pb-2 border bg-white border">
      <FormGroup  className="mb-3">
        <DropdownButton
          id="questionTypeDropDown"
          disabled={disabled}
          title={
            question.predefinedListType
              ? intl.formatMessage({ id: `survey.editor.predefined.list.${question.predefinedListType.toLowerCase()}` })
              : intl.formatMessage({ id: "app.common.Select" })
          }
          onSelect={(e) => loadPredefinedList(pageName, question.name, PREDEFINED_LIST_TYPE, e)}
        >
          <DropdownItem eventKey="COUNTRIES">
            <FormattedMessage id="survey.editor.predefined.list.countries" />
          </DropdownItem>
          <DropdownItem eventKey="COUNTRY_REDUCED">
            <FormattedMessage id="survey.editor.predefined.list.country_reduced" />
          </DropdownItem>
          <DropdownItem eventKey="REGIONS">
            <FormattedMessage id="survey.editor.predefined.list.regions" />
          </DropdownItem>
          <DropdownItem eventKey="FIELD_OF_STUDY">
            <FormattedMessage id="survey.editor.predefined.list.field_of_study" />
          </DropdownItem>
          <DropdownItem eventKey="SUBJECT_OF_STUDY">
            <FormattedMessage id="survey.editor.predefined.list.subject_of_study" />
          </DropdownItem>
          <DropdownItem eventKey="DEGREE">
            <FormattedMessage id="survey.editor.predefined.list.degree" />
          </DropdownItem>
          <DropdownItem eventKey="SUBJECT_OF_STUDY_TEACHER">
            <FormattedMessage id="survey.editor.predefined.list.subject_of_study_teacher" />
          </DropdownItem>
          <DropdownItem eventKey="STATES">
            <FormattedMessage id="survey.editor.predefined.list.states" />
          </DropdownItem>
        </DropdownButton>
      </FormGroup>
      <FormGroup  className="mb-3">
        <Checkbox
          checked={question[coalesce(otherOptionField, OTHER_OPTION)]}
          onChange={(e) => {
            changeQuestionField(pageName, question.name, coalesce(otherOptionField, OTHER_OPTION), e.target.checked);
          }}
        >
          <FormattedMessage id="survey.editor.toolbox.radio.other" />{" "}
          <InfoTooltip infoText={intl.formatMessage({ id: "survey.editor.toolbox.radio.other.info" })} />
        </Checkbox>
      </FormGroup>
    </Container>
  </>
);

MultiChoice.propTypes = {
  changeQuestionField: PropTypes.func,
  addQuestionChoice: PropTypes.func,
  removeQuestionChoice: PropTypes.func,
  reorderChoice: PropTypes.func,
  loadPredefinedList: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  loadIndicators: PropTypes.func,
  pageName: PropTypes.string,
  question: PropTypes.object,
  intl: PropTypes.object,
  allIndicators: PropTypes.array
};

ConfigComponent.propTypes = {
  changeQuestionField: PropTypes.func,
  addQuestionChoice: PropTypes.func,
  removeQuestionChoice: PropTypes.func,
  reorderChoice: PropTypes.func,
  loadPredefinedList: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  loadIndicators: PropTypes.func,
  pageName: PropTypes.string,
  choiceTarget: PropTypes.string,
  parentChoiceName: PropTypes.string,
  exclusiveName: PropTypes.string,
  parentChoiceTarget: PropTypes.string,
  question: PropTypes.object,
  intl: PropTypes.object,
  allIndicators: PropTypes.array,
  showExclusive: PropTypes.bool,
  otherOptionField: PropTypes.bool
};

PredefinedList.propTypes = {
  changeQuestionField: PropTypes.func,
  loadPredefinedList: PropTypes.func,
  pageName: PropTypes.string,
  question: PropTypes.object,
  intl: PropTypes.object,
  otherOptionField: PropTypes.bool,
  disabled: PropTypes.bool
};

MultiChoice.Config = ConfigComponent;
MultiChoice.Predefined = PredefinedList;
